'use client';

import { Video } from '@/app/elements/video/video';
import './styles/default.scss';

type ExclusivePreLaunchTrailerLandscapeProps = {
    id: string;
    url?: string;
    poster?: string;
    gameUid?: string;
};

export const ExclusivePreLaunchTrailerLandscape: React.FC<ExclusivePreLaunchTrailerLandscapeProps> = ({
    url,
    id,
    poster,
    gameUid
}) => {
    if (!url) {
        return null;
    }

    return (
        <div className="exclusive-prelaunch__trailer--landscape">
            <Video
                uid={gameUid || ''}
                src={url}
                videoId={`exclusive-pre-launch-video-${id}`}
                poster={poster}
                inPopup={false}
                disableGameLauncher={true}
                hasVideoDetails={false}
                videosPlaying={true}
            />
        </div>
    );
};
